// extracted by mini-css-extract-plugin
export default {"loginContent":"Login_loginContent__Q+d1s","loginForm":"Login_loginForm__Urk4o"};